import React, { useState } from "react";
import { PriPPLWise } from "../../../Components/KPI/PriPPLWise";
import First from "../../../Artifacts/ILMCVT.png";
import Second from "../../../Artifacts/SCVPU.png";
import Third from "../../../Artifacts/HCV.png";
import Fourth from "../../../Artifacts/ILMCV.png";
import { axInst } from "../../../Components/Login/Service";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import RetailpplModal from "../../../Components/Modals/RetailPplModal";

/* ---------------- API CALL ---------------- */
const fetchPPLWiseRealization = async (body) => {
  try {
    const res = await axInst.post("realization/lob_wise_realization", body);
    return res.data.ppl_wise_retail;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const LobRealization = () => {
  const [selOps, setSelOps] = useState({ retail_status: "Realization" });
  const { data, submitted } = useSelector((e) => e.filtersRealization);
  const [selectedOption, setSelectedOption] = useState("Realization");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const {
    data: offtakeData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["ppl", submitted, selOps.retail_status],
    queryFn: () => fetchPPLWiseRealization({ ...data, ...selOps }),
    refetchInterval: 300000,
    cacheTime: 0,
    staleTime: 0,
    refetchIntervalInBackground: true,
  });

  /* ---------------- HELPERS ---------------- */
  const formatDecimal = (value) => {
    const num = Number(value || 0);

    // ONLY for Realization → force 2 decimals
    if (selOps.retail_status === "Realization") {
      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    // For all other cases → normal formatting (no decimals)
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
    });
  };

  const getAverage = (obj) => {
    const values = Object.values(obj || {}).map((v) => Number(v || 0));
    if (!values.length) return 0;
    return values.reduce((a, b) => a + b, 0) / values.length;
  };

  const getTotal = (obj) => {
    const values = Object.values(obj || {}).map((v) => Number(v || 0));
    return values.reduce((a, b) => a + b, 0);
  };

  const formatNumber = (value) => {
    const nfaStatuses = [
      "Approved-nfa",
      "Pending-nfa",
      "Partially-retailed-nfa",
    ];

    const formatted = formatDecimal(value);

    if (selOps.retail_status === "Realization") {
      return `${formatted} %`;
    } else if (
      selOps.retail_status === "MOP" ||
      selOps.retail_status === "Discount"
    ) {
      return `₹ ${formatted}`;
    } else if (nfaStatuses.includes(selOps.retail_status)) {
      return formatted;
    } else {
      return formatted;
    }
  };

  const getDisplayValue = (obj) => {
    const val =
      selOps.retail_status === "Realization" ? getAverage(obj) : getTotal(obj);

    return formatNumber(val);
  };

  const formatItems = (obj) => {
    const nfaStatuses = [
      "Approved-nfa",
      "Pending-nfa",
      "Partially-retailed-nfa",
    ];

    return Object.entries(obj || {}).map(([label, value]) => {
      const formatted = formatDecimal(value);

      let formattedValue;

      if (selOps.retail_status === "Realization") {
        formattedValue = `${formatted} %`;
      } else if (
        selOps.retail_status === "MOP" ||
        selOps.retail_status === "Discount"
      ) {
        formattedValue = `₹ ${formatted}`;
      } else if (nfaStatuses.includes(selOps.retail_status)) {
        formattedValue = formatted;
      } else {
        formattedValue = formatted;
      }

      return { label, value: formattedValue };
    });
  };

  /* ---------------- HANDLERS ---------------- */

  const handleSelectionChange = (event) => {
    const selection = event.target.value;
    setSelOps({ retail_status: selection });
    setSelectedOption(selection);
  };

  const handleItemClick = (label, icon, alt, darkcolor, title) => {
    setModalData({
      lob: [label],
      selOps,
      clickedLabel: label,
      icon,
      alt,
      darkcolor,
      Product_Line: title,
      api: "/realization/ppl_wise_realization",
    });
    setIsModalOpen(true);
  };

  /* ---------------- UI ---------------- */

  return (
    <div className="grid grid-rows-[auto_1fr] px-2 py-2 bg-white rounded-md relative">
      {/* Header */}
      <section className="flex justify-between pb-[18px]">
        <header className="pb-2 text-base font-semibold text-[#545454]">
          LOB Wise Realization
        </header>

        <select
          value={selectedOption}
          onChange={handleSelectionChange}
          className="border border-gray-300 text-sm rounded-md h-6 w-28"
        >
          <option value="Realization">Realization (%)</option>
          <option value="MOP">MOP (₹)</option>
          <option value="Discount">Discount (₹)</option>
          <option value="Total-raised-nfa">Total Raised NFA</option>
          <option value="Approved-nfa">Approved NFA</option>
          <option value="Pending-nfa">Pending NFA</option>
          <option value="Approved-nfa-not-retailed">
            Approved(Not Retailed)
          </option>
          <option value="partially-retailed-nfa">Partially Retailed NFA</option>
        </select>
      </section>

      {/* Cards */}
      <div className="grid gap-2 lg:grid-cols-1 md:grid-cols-2">
        {isFetching && (
          <div className="flex justify-center items-center">
            <Loader />
          </div>
        )}

        {isError && <p>Error loading data</p>}

        {!isFetching && offtakeData && (
          <>
            <PriPPLWise
              onItemClick={(label) =>
                handleItemClick(
                  label,
                  First,
                  "ILMCV Trucks",
                  "bg-[#08B7C3] text-[#A2EDF2]",
                  "ILMCV Trucks",
                )
              }
              darkcolor="bg-[#08B7C3] text-[#A2EDF2]"
              color="bg-[#A2EDF2]"
              icon={First}
              title="ILMCV TRUCKS"
              total={getDisplayValue(offtakeData?.["ILMCV Trucks"])}
              items={formatItems(offtakeData?.["ILMCV Trucks"])}
            />

            <PriPPLWise
              onItemClick={(label) =>
                handleItemClick(
                  label,
                  Second,
                  "SCV & PU",
                  "bg-[#4F81BA] text-[#DBECFF]",
                  "SCV & PU",
                )
              }
              darkcolor="bg-[#4F81BA] text-[#DBECFF]"
              color="bg-[#DBECFF]"
              icon={Second}
              title="SCV & PU"
              total={getDisplayValue(offtakeData?.["SCV & PU"])}
              items={formatItems(offtakeData?.["SCV & PU"])}
            />

            <PriPPLWise
              onItemClick={(label) =>
                handleItemClick(
                  label,
                  Third,
                  "HCV TRUCKS",
                  "bg-[#ccad5e] text-[#fff3d4]",
                  "HCV TRUCKS",
                )
              }
              darkcolor="bg-[#ccad5e] text-[#fff3d4]"
              color="bg-[#fff3d4]"
              icon={Third}
              title="HCV TRUCKS"
              total={getDisplayValue(offtakeData?.["HCV Trucks"])}
              items={formatItems(offtakeData?.["HCV Trucks"])}
            />

            <PriPPLWise
              onItemClick={(label) =>
                handleItemClick(
                  label,
                  Fourth,
                  "CV Passengers",
                  "bg-[#FF8E33] text-[#FFC699]",
                  "CV Passengers",
                )
              }
              darkcolor="bg-[#FF8E33] text-[#FFC699]"
              color="bg-[#FFC699]"
              icon={Fourth}
              title="CV Passengers"
              total={getDisplayValue(offtakeData?.["CV Passenger"])}
              items={formatItems(offtakeData?.["CV Passenger"])}
            />
          </>
        )}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <RetailpplModal
          closeModal={() => setIsModalOpen(false)}
          modalData={modalData}
        />
      )}
    </div>
  );
};
